/**
 * Sørger for at alle api kall der kun root-url er angitt (/api/..) blir prefikset med
 * konfigurasjon.serviceRotUrl
 */
import {IHttpProvider, IRequestConfig} from "angular";
import {Konfigurasjon} from "./Konfigurasjon";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";


var erApiKallUrl = /\/api\//;

export function registrerAPIKallUrlInterceptor($httpProvider: IHttpProvider, konfigurasjon: Konfigurasjon) {

    var requestInterceptor = () => {
        return {
            request: (konfig: IRequestConfig) => {
                if (erApiKallUrl.test(konfig.url))
                    konfig.url = konfigurasjon.serviceRotUrl + konfig.url;
                return konfig;
            }
        }
    };

    $httpProvider.interceptors.push(requestInterceptor);
}

export function registrerAPIKallUrlInterceptorForInjisering() {
    return [
        regNavn.ng.$httpProvider,
        Konfigurasjon.regNavn,
        registrerAPIKallUrlInterceptor
    ];
}
    